import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'chrysalis-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'CHRYS Counseling',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8885870335,
  email: 'support@chryscounseling.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/chrysalis/index.js